import { Component, OnInit } from '@angular/core';
import { InterviewDataService } from './services/interview-data.service'
import { RequestFeedbackComponent } from './request-feedback.component';
import { FeedbackSentComponent } from './feedback-sent.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var window:any;
@Component({
    selector: 'interview-complete',
    templateUrl: './interview-complete.component.html',
    standalone: false
})
export class InterviewCompleteComponent implements OnInit {

    instructions:any;
    attemptId:any;
    current:any;

    constructor(private modalService: NgbModal,
                public _dataService: InterviewDataService) {}

    ngOnInit() {
        this._dataService.getAttempt(this._dataService.attemptId);
        this._dataService.attempt.subscribe((resp:any) => {
            if (resp) {
                this.current = resp[0];
            }
        });
        this._dataService.loadReviewerSettings();
    }

    openRequestFeedbackModal() {
        let modalRef = this.modalService.open(RequestFeedbackComponent, {container : '.interviews-modal-container'});
        modalRef.componentInstance.id = 'feedback';
        modalRef.componentInstance.questions = this.current?.questions || [];
        modalRef.componentInstance.feedbackReq.subscribe(($e) => {
            this._dataService.requestFeedback($e);
            modalRef.dismiss();
            this.modalService.open(FeedbackSentComponent, {container : '.interviews-modal-container'});
        });
    }

    exitInterview() {
        let tab = sessionStorage.getItem('tab');
        window.parent.location.href = '/students/index.php?s=resource&ss=video_interviews&mode=list&tab=' + tab;
    }
}

